var IS_PURE = require('../internals/is-pure');
var store = require('../internals/shared-store');

(module.exports = function (key, value) {
	return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
	version: '3.19.2',
	mode: IS_PURE ? 'pure' : 'global',
	copyright: '(c) 2021 Denis Pushkarev (zloirock.ru)'
});
